import {
  Box,
  Button,
  ButtonGroup,
  Card,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import React, { useEffect, useState, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { HeaderBlock } from "../../../components/header-block/HeaderBlock";
import { Loading } from "../../../components/loading/Loading";
import PageContainer from "../../../components/page-container/PageContainer";
import {
  getObjective,
  deleteObjectives,
  updateObjectives,
} from "../../../state/actions/ObjectiveActions";
import styles from "./ViewObjectivePage.module.scss";
import Input from "@material-ui/core/Input";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { useTranslation } from "react-i18next";
import { ObjectiveType } from "../../../state/constants/ObjectiveConstants";


const useStyles = makeStyles({
  input: {
    fontSize: "14px",
    textAlign: "right",
  },
  formControlRoot: {
    display: "flex",
    alignItems: "flex-end",
  },
});

function ViewObjectivePage(props) {
  const dispatch = useDispatch();
  const classes = useStyles(props);
  const [t, i18n] = useTranslation()

  let reducerObjective = useSelector(
    (state) => state.ObjectivesReducer.objective
  );

  const [loading, setLoading] = useState(false);
  const [editing, setEditing] = useState(false);
  const [objective, setObjective] = useState(reducerObjective);
  const [uneditedObjective, setUneditedObjective] = useState(reducerObjective);

  useEffect(() => {
    setLoading(true);
    const objectiveId = props.match.params.objectiveId;

    dispatch(
      getObjective(objectiveId, (data) => {
        setLoading(false);

        if (data == null) {
          setObjective({});
          setUneditedObjective({});
        } else {
          setObjective(data);
          setUneditedObjective(data);
        }
      })
    );
  }, []);

  function getContent() {
    var fields = [];

    if (objective.ObjectiveType == ObjectiveType().admin.key) {
      fields = [
        { id: "Title", label: t('common.title'), editable: true },
        { id: "Description", label: t('common.description'), editable: true },
        { id: "DueTime", label: t('objective.due-time'), editable: true, type: "date" },
        { id: "CreatedAt", label: t('common.created-at'), editable: false, type: "date" },
        { id: "SubType", label: t('objective.sub-type'), editable: true },
        { id: "CustomSubType", label: t('objective.custom-sub-type'), editable: false, type: "boolean" },
        {
          id: "ExpirationDate",
          label: t('objective.expiration-date'),
          editable: true,
          type: "date",
        },
        {
          id: "CompleteInCall",
          label: t('objective.must-complete-in-call'),
          editable: true,
          type: "boolean",
        },
        { id: "Active", label: t('common.active'), editable: false, type: "boolean" },
      ];
    } else if (objective.ObjectiveType == "admin_route") {
      fields = [
        { id: "Title", label: t('common.title'), editable: true },
        { id: "Description", label: t('common.description'), editable: true },
        { id: "DueTime", label: t('objective.due-time'), editable: true, type: "date" },
        { id: "CreatedAt", label: t('common.created-at'), editable: false, type: "date" },
        { id: "SubType", label: t('objective.sub-type'), editable: true },
        { id: "CustomSubType", label: t('objective.custom-sub-type'), editable: false, type: "boolean" },
        {
          id: "ExpirationDate",
          label: t('objective.expiration-date'),
          editable: true,
          type: "date",
        },
        { id: "Active", label: t('common.active'), editable: false, type: "boolean" },
      ];
    } else {
      fields = [
        { id: "CustomerId", label: t('customer.customer-id'), editable: false },
        { id: "Title", label: t('common.title'), editable: true },
        { id: "Description", label: t('common.description'), editable: true },
        { id: "DueTime", label: t('objective.due-time'), editable: true, type: "date" },
        { id: "CreatedAt", label: t('common.created-at'), editable: false, type: "date" },
        { id: "Completed", label: t('objective.completed'), editable: false },
        { id: "CompletedAt", label: t('objective.completed-at'), editable: false },
        { id: "SubType", label: t('objective.sub-type'), editable: true },
        { id: "CustomSubType", label: t('objective.custom-sub-type'), editable: false, type: "boolean" },
        {
          id: "ExpirationDate",
          label: t('objective.expiration-date'),
          editable: true,
          type: "date",
        },
        { id: "Active", label: t('common.active'), editable: false },
      ];
    }

    return fields.map((field) => {
      return (
        <div className={styles.fieldContainer}>
          <div className={styles.fieldName}>{field.label}</div>
          <div className={styles.fieldValue}>
            <FormControl classes={{ root: classes.formControlRoot }} fullWidth>
              {renderInput(field)}
            </FormControl>
          </div>
        </div>
      );
    });
  }

  function renderInput(field) {
    let fieldValue = objective[field.id];
    let fieldDisabled =
      editing && (objective.ObjectiveType == ObjectiveType().admin.key || objective.ObjectiveType == ObjectiveType().admin_route.key) ? !field.editable : true;

    if (field.type == "date") {
      let dateValue = null;

      if (fieldValue != undefined && fieldValue != "" && fieldValue != null) {
        dateValue = new Date(fieldValue).toISOString().split("T")[0];
      }

      return (
        <Fragment>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              margin="dense"
              classes={{ input: classes.input }}
              disableToolbar
              variant="inline"
              disabled={fieldDisabled}
              inputVariant="outlined"
              format="dd/MM/yyyy"
              value={dateValue}
              onChange={(date) => {
                let key = field.id;
                setObjective({ ...objective, [key]: date });
              }}
            />
          </MuiPickersUtilsProvider>
        </Fragment>
      );
    } else if (field.type == "boolean") {
      return renderCheck(field, fieldValue, fieldDisabled);
    } else {
      return (
        <Input
          classes={{ input: classes.input }}
          onChange={(event) => {
            let key = field.id;
            let value = event.target.value;
            setObjective({ ...objective, [key]: value });
          }}
          disabled={fieldDisabled}
          disableUnderline={true}
          value={fieldValue}
        />
      );
    }
  }

  function saveObjective() {
    dispatch(
      updateObjectives([objective], () => {
        // Editing...
      })
    );
  }

  function deleteObjective() {
    dispatch(
      deleteObjectives([objective], () => {
        let url = props.match.url;
        const param = props.match.params.objectiveId;
        url = url.replace(param, "");
        props.history.push(url);
      })
    );
  }

  function archiveObjective() {
    var activeStatus = false;

    if (objective.hasOwnProperty("Active")) {
      activeStatus = !objective.Active;
    }

    let newObjective = {
      ...objective,
      Active: activeStatus,
    };

    dispatch(
      updateObjectives([newObjective], () => {
        if (objective != false) {
          setUneditedObjective(newObjective);
          setObjective(newObjective);
        }
      })
    );
  }

  function renderCheck(field, value, disabled) {
    return (
      <FormControlLabel
        classes={{ root: classes.formControlRoot }}
        control={
          <Checkbox onChange={(event) => {
            let key = field.id;
            setObjective({ ...objective, [key]: event.target.checked });
          }} disabled={disabled} checked={value} name="complete" />
        }
      />
    );
  }

  function setupButtonGroup() {
    return (
      <div className={styles.buttonContainer}>
        <div className={styles.deleteButton}>
          <Button
            className={styles.deleteButton}
            variant="outlined"
            color="primary"
            onClick={() => {
              deleteObjective();
            }}
          >
            {t('common.delete')}
          </Button>
        </div>
        <div className={styles.deleteButton}>
          <Button
            className={styles.deleteButton}
            variant="outlined"
            color="secondary"
            onClick={() => {
              archiveObjective();
            }}
          >
            {objective.Active ? t('objective.archive') : t('objective.reactivate')}
          </Button>
        </div>
        <ButtonGroup>
          {editing ? (
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => {
                setEditing(false);
                setObjective(uneditedObjective);
              }}
            >
              {t('common.cancel')}
            </Button>
          ) : null}
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => {
              if (editing) {
                saveObjective();
              }
              setEditing(!editing);
            }}
          >
            {editing ? t('common.done') : t('common.edit')}
          </Button>
        </ButtonGroup>
      </div>
    );
  }

  return (
    <Box>
      <HeaderBlock
        title={objective.Title}
        right={(objective.ObjectiveType == ObjectiveType().admin.key || objective.ObjectiveType == ObjectiveType().admin_route.key) && setupButtonGroup()}
      />
      <PageContainer>
        {loading ? (
          <Loading />
        ) : (
            <Fragment>
              <Card className={styles.editCard}>
                <div className={styles.cardHeader}>{t('common.details')}</div>
                {getContent()}
              </Card>
            </Fragment>
          )}
      </PageContainer>
    </Box>
  );
}

export default ViewObjectivePage;
